/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDown: {
  name: 'arrow-down';
  data: string;
} = {
  name: 'arrow-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .5.5v12.793l4.146-4.147a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.708L7.5 13.793V1A.5.5 0 0 1 8 .5Z" fill="currentColor"/></svg>`,
};
